// Lucide icon: chevrons-up-down (https://lucide.dev/icons/chevrons-up-down)
import { ChevronsUpDown } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconChevronUpDown = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <ChevronsUpDown />
    </IconComponentStyled>
  )
}
